import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { patientOfflineStore } from '@/core/offline'

export function useDeletePatient() {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [isDeletingPatient, setIsDeletingPatient] = useState(false)

  const deletePatient = useCallback(async (patientId: string, onPatientDeleted?: () => void) => {
    try {
      setIsDeletingPatient(true)

      // Delete the patient from offline storage
      await patientOfflineStore.delete(patientId)

      enqueueSnackbar(t('notification.patient.delete.success'), { variant: 'success' })

      // Call the callback to notify parent component
      onPatientDeleted?.()

      // Navigate back to patients list
      navigate('/offline/patients')
    } catch (error) {
      console.error('Error deleting offline patient:', error)
      enqueueSnackbar(t('notification.patient.delete.error'), { variant: 'error' })
    } finally {
      setIsDeletingPatient(false)
    }
  }, [])

  return [deletePatient, isDeletingPatient] as const
}
